import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import CheckpointForm from '../forms/CheckpointForm';
import CustomLoader from '../shared/CustomLoader';
import CheckpointsTable from '../tables/CheckpointsTable';
import { handleError } from '../../utilities/errorHandler';
import { addCheckpoint, allCheckpoints, oneCheckpoint, removeCheckpoint, updateCheckpoint } from '../../services/checkpoints';

const Checkpoints = () => {
    const [ checkpoint, setCheckpoint] = useState(null);
    const [ checkpoints, setCheckpoints] = useState([]);
    const [ isSaving, setIsSaving] = useState(false);
    const [ isLoading, setIsLoading] = useState(false);
    const [ message, setMessage] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const getCheckpoint = (id) => {
        oneCheckpoint(id).then((response) => {
            if (response.status === 200){
                setCheckpoint(response.data);
            }
        }).catch(error => {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        });
    }

    const deleteCheckpoint = async (id) => {
        try {
            await removeCheckpoint(id);
            handleMessage('Checkpoint successfully deleted', 'success');
            getCheckpoints();
        } catch (error){
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        }
    }

    const saveSiteLocation = async (data) => {
        setIsSaving(true);
        try {
            const checkpointData = {
                name: data.name,
                site_id: data.site.value,
                geo_fence_radius: data.geo_fence_radius,
                latitude: data.latitude,
                longitude: data.longitude,
                rfid_tag_id: data.rfid_tag_id
            }

            if (data.id){
                await updateCheckpoint(data.id, checkpointData);
                handleMessage('Checkpoint successfully updated', 'success');
                getCheckpoints();

                return true;
            } else {
                await addCheckpoint(checkpointData);
                handleMessage('Checkpoint successfully saved', 'success');
                getCheckpoints();

                return true;
            }
        } catch (error){
            try {
                const errorMessage = handleError(error);
                console.log()
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch (e){
                // error to be handled by onSubmit in SiteLocationForm.jsx 
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }

    const getCheckpoints = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await allCheckpoints();
            if (response.status === 200){
                setCheckpoints(response.data);
            }
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getCheckpoints();
    }, [getCheckpoints]);
    
  return (
    <Container fluid>

        <PageTitle 
            title='Checkpoint Details'
        />

        <Message
            message={message.text}
            variant={message.variant}
            show={message.show}
            handleClose={handleCloseMessage}
        />

        <CheckpointForm
            isSaving={isSaving}
            formAction={saveSiteLocation}
            siteLocation={checkpoint}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <CheckpointsTable 
                    checkpoints={checkpoints}
                    onDelete={deleteCheckpoint}
                    onEdit={getCheckpoint}
                />
            )
        }

    </Container>
  )
}

export default Checkpoints